export default {
  order_again: 'Bestil igen',
  error_messages: {
    product_does_not_exist: 'Produktet er ikke længere tilgængeligt',
  },
  success_messages: {
    product_added_to_card: 'Produkt lagt i kurven',
  },
};
